import { CustomReportRiskResults } from './enum';
import {
	NONE_RISK_COLOR,
	HIGH_RISK_COLOR,
	SERIOUS_RISK_COLOR,
	MODERATE_RISK_COLOR,
	VERY_HIGH_RISK_COLOR,
	ACCEPTABLE_RISK_COLOR,
	RULA_SERIOUS_RISK_SCORE,
	REBA_MIN_HIGH_RISK_SCORE,
	REBA_MIN_SERIOUS_RISK_SCORE,
	REBA_MIN_MODERATE_RISK_SCORE,
	RULA_MIN_MODERATE_RISK_SCORE,
	RULA_MIN_VERY_HIGH_RISK_SCORE,
	REBA_MIN_VERY_HIGH_RISK_SCORE,
	REBA_MIN_ACCEPTABLE_RISK_SCORE,
	RULA_MIN_ACCEPTABLE_RISK_SCORE
} from './constants';

export type RiskLevel = {
	[key: number]: string;
};

export const riskLevels: RiskLevel = {
	1: 'Acceptable risk',
	2: 'Moderate risk',
	3: 'High Risk',
	4: 'Very high risk',
	5: 'Serious and imminent risk'
};

export const customReportPaletteMap: Record<number, string> = {
	[CustomReportRiskResults.LOW]: '#2CC852',
	[CustomReportRiskResults.MODERATE]: '#FFDE31',
	[CustomReportRiskResults.HIGH]: '#F78A38',
	[CustomReportRiskResults.VERY_HIGH]: '#E74150',
	[CustomReportRiskResults.EXTREME]: '#9B54E2'
};

export const REBA_DEFAULT_RISK_RANGE = [
	{ min: 0, max: 2, color: ACCEPTABLE_RISK_COLOR },
	{ min: 2, max: 4, color: MODERATE_RISK_COLOR },
	{ min: 4, max: 8, color: HIGH_RISK_COLOR },
	{ min: 8, max: 11, color: VERY_HIGH_RISK_COLOR },
	{ min: 11, max: 13, color: SERIOUS_RISK_COLOR }
];

export function rosaPaletteMap(score: number): string {
	return score > 5 ? '#E74150' : '#2CC852';
}

export function getRebaColorByScore(value: number): string {
	if (value >= REBA_MIN_SERIOUS_RISK_SCORE) {
		return SERIOUS_RISK_COLOR;
	}

	if (value >= REBA_MIN_VERY_HIGH_RISK_SCORE) {
		return VERY_HIGH_RISK_COLOR;
	}

	if (value >= REBA_MIN_HIGH_RISK_SCORE) {
		return HIGH_RISK_COLOR;
	}

	if (value >= REBA_MIN_MODERATE_RISK_SCORE) {
		return MODERATE_RISK_COLOR;
	}

	if (value >= REBA_MIN_ACCEPTABLE_RISK_SCORE) {
		return ACCEPTABLE_RISK_COLOR;
	}

	return NONE_RISK_COLOR;
}

export function getRulaColorByScore(value: number = 0): string {
	if (value === RULA_SERIOUS_RISK_SCORE) {
		return SERIOUS_RISK_COLOR;
	}

	if (value >= RULA_MIN_VERY_HIGH_RISK_SCORE) {
		return VERY_HIGH_RISK_COLOR;
	}

	if (value >= RULA_MIN_MODERATE_RISK_SCORE) {
		return MODERATE_RISK_COLOR;
	}

	if (value >= RULA_MIN_ACCEPTABLE_RISK_SCORE) {
		return ACCEPTABLE_RISK_COLOR;
	}

	return NONE_RISK_COLOR;
}
